import React from 'react';

export const AdventureLog = ({ name, items = [] }) => {
  if (!items.length) return null;
  return (
    <div className="home-card" data-testid="adventure-log">
      <p className="text-xs uppercase tracking-[0.25em] text-white/60 font-bold">{name}'s adventures</p>
      <ul className="mt-3 space-y-3">
        {items.map((a) => (
          <li key={a.id} data-testid={`adventure-log-${a.id}`}>
            <p className="text-sm text-white/90"><span className="font-bold">{a.place}</span> · met {a.encounter?.name}
              <span className="text-white/55"> ({a.encounter?.label})</span></p>
            <p className="text-xs text-white/60">found {a.discovery?.title}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdventureLog;
